import { FC, Fragment } from 'react'
import tw from 'twin.macro'

import arrowLeft from '../../images/icons/carousel-arrow-left.svg'
import arrowRight from '../../images/icons/carousel-arrow-right.svg'

type Props = {
  prevSlide: () => void
  nextSlide: () => void
  dotCount: number
  activeDotIndex: number
}

export const FlickityControls: FC<Props> = ({
  prevSlide,
  nextSlide,
  dotCount,
  activeDotIndex,
}) => {
  const dotIndexArray = Array.from(Array(dotCount), (_, index) => index + 1)
  return (
    <Fragment>
      <div tw="bottom-[-46px] absolute w-full px-8">
        <div tw="flex justify-between items-center lg:(justify-center)">
          <button tw="w-8 lg:hidden" onClick={prevSlide}>
            <img src={arrowLeft} tw="w-8" alt="" />
          </button>

          <div tw="flex justify-center items-center">
            {dotIndexArray.map((index) => (
              <div
                key={`dot-${index}`}
                css={[
                  tw`w-[5px] h-[5px] inline-block bg-gb-blue opacity-50 border-radius[100%] mx-[5px]`,
                  activeDotIndex === index && tw`opacity-100`,
                ]}
              />
            ))}
          </div>

          <button tw="w-8 lg:hidden" onClick={nextSlide}>
            <img src={arrowRight} tw="w-8" alt="" />
          </button>
        </div>
      </div>

      <button
        tw="w-8 absolute top-1/2 translate-y-[-50%] -left-10 mr-4 hidden lg:block"
        onClick={prevSlide}
      >
        <img src={arrowLeft} tw="w-8" alt="" />
      </button>
      <button
        tw="w-8 absolute top-1/2 translate-y-[-50%] -right-10 ml-4 hidden lg:block"
        onClick={nextSlide}
      >
        <img src={arrowRight} tw="w-8" alt="" />
      </button>
    </Fragment>
  )
}

export const FlickityCircularPrevNextButtons: FC<Props> = ({
  prevSlide,
  nextSlide,
}) => (
  <Fragment>
    <button
      css={[
        tw`absolute w-8 h-8 rounded-full bg-white md:(hover:opacity-50) top-1/2 translate-y-[-50%] -left-5 mr-4`,
        tw`hidden lg:block`,
      ]}
      onClick={prevSlide}
    >
      <img src={arrowLeft} tw="w-7 mx-0.5" alt="" />
    </button>
    <button
      css={tw`absolute w-8 h-8 rounded-full bg-white md:(hover:opacity-50) top-1/2 translate-y-[-50%] -right-5 ml-4`}
      onClick={nextSlide}
    >
      <img src={arrowRight} tw="w-7 mx-0.5" alt="" />
    </button>
  </Fragment>
)
